import React, { useState } from 'react';
import { bool, string, func } from 'prop-types';
import Flex from '../../atoms/Flex';
import { AnimatedLoader, Container, Icon, Label, StyledButton, StyledSpan, StyledInput } from './zipcode-input.styles';
import zipcodeMask from '../../utils/zipcodeMask';

function ZipcodeInput({
  errorText,
  hasError,
  initialValue,
  labelText,
  loading,
  locationButtonText,
  onChange,
  placeholder,
  showButton,
  inputButtonText,
  onClickLocationButton
}) {
  const [zipcode, setZipcode] = useState(zipcodeMask(initialValue));

  const handleChange = e => {
    e.preventDefault();
    const {
      value
    } = e.target;
    setZipcode(zipcodeMask(value));
    onChange(e, e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();
    setZipcode(zipcodeMask(zipcode));
    onChange(e, zipcode);
  };

  return /*#__PURE__*/React.createElement(Container, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Label, {
    "data-testid": "zipcode-label",
    hasError: hasError,
    htmlFor: "zipcode"
  }, !hasError ? labelText : errorText), loading && /*#__PURE__*/React.createElement(Icon, {
    "data-testid": "zipcode-loading"
  }, /*#__PURE__*/React.createElement(AnimatedLoader, null)), /*#__PURE__*/React.createElement(StyledInput, {
    "data-testid": "zipcode-input",
    hasError: hasError,
    autoFocus: true,
    id: "zipcode",
    name: "zipcode",
    type: "text",
    inputMode: "numeric",
    maxLength: 9,
    placeholder: placeholder,
    onChange: handleChange,
    value: zipcode,
    onInput: handleChange,
    disabled: loading
  }), showButton && /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "center",
    my: 2
  }, inputButtonText && /*#__PURE__*/React.createElement(StyledButton, {
    disabled: zipcode.length !== 9,
    "data-testid": "zipcode-button"
  }, inputButtonText), locationButtonText && /*#__PURE__*/React.createElement(StyledSpan, {
    "data-testid": "location-button",
    variation: "outline",
    boxShadow: 'none',
    onClick: onClickLocationButton
  }, locationButtonText)));
}

ZipcodeInput.defaultProps = {
  hasError: false,
  initialValue: '',
  loading: false,
  locationButtonText: undefined,
  onChange: undefined,
  showButton: false,
  inputButtonText: undefined,
  onClickLocationButton: () => {}
};
process.env.NODE_ENV !== "production" ? ZipcodeInput.propTypes = {
  errorText: string.isRequired,
  hasError: bool,
  initialValue: string,
  labelText: string.isRequired,
  loading: bool,
  locationButtonText: string,
  onChange: func,
  placeholder: string.isRequired,
  showButton: bool,
  inputButtonText: string,
  onClickLocationButton: func
} : void 0;
export default ZipcodeInput;